import "@css/main.scss";
import "@js/bootstrap";

import {Header} from "@js/components/Header";
import {Slider} from "@js/components/Slider";
import {Mask} from "@js/animations/Mask";
import {Stagger} from "@js/animations/Stagger";
import {Wipe} from "@js/animations/Wipe";
import {Translate} from "@js/animations/Translate";
import {Shape} from "@js/animations/Shape";
import {Zoom} from "@js/animations/Zoom";
import {CustomFloating} from "@js/components/CustomFloating";
import {Scroll} from "@js/animations/Scroll";
import {createRoot} from "react-dom/client";
import App from "@js/Map/app";
import React from "react";
import {Service1} from "@js/components/Service-1";
import {Tabs} from "@js/components/Tabs";

window.onload = () => {
  const animations = [Mask, Stagger, Wipe, Scroll, Translate, Shape, Zoom];

  animations.forEach((animation) => {
    new animation();
  });

  new Header();
  new Slider();
  new CustomFloating();
  new Service1();
  new Tabs();

  const map = document.getElementById("carte-adherents");

  if (map) {
    const root = createRoot(map);
    root.render(React.createElement(App));
  }
};
